import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SortableExerciseItem = ({ exercise, index, isSelected, duration, onSelect, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: exercise?.id,
  });

  const style = {
    transform: CSS?.Transform?.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const categoryIcons = {
    strength: 'Dumbbell',
    cardio: 'Heart',
    flexibility: 'Sparkles',
    balance: 'Target',
    sports: 'Trophy'
  };

  return (
    <div ref={setNodeRef} style={style}>
      <motion.div
        className={`p-4 rounded-lg border transition-all cursor-pointer ${
          isSelected
            ? 'bg-primary/10 border-primary shadow-md'
            : 'bg-muted border-border hover:border-primary/50'
        }`}
        onClick={onSelect}
        whileHover={{ scale: 1.01 }}
      >
        <div className="flex items-start gap-3">
          <div
            {...attributes}
            {...listeners}
            className="cursor-grab active:cursor-grabbing mt-1 touch-none"
          >
            <Icon name="GripVertical" size={20} className="text-muted-foreground" />
          </div>

          <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <span className="text-sm font-bold text-primary">{index + 1}</span>
          </div>

          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon
              name={categoryIcons?.[exercise?.category] || 'Dumbbell'}
              size={20}
              className="text-primary"
            />
          </div>

          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold text-foreground">{exercise?.name}</h3>
            <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground">
              <span>{exercise?.sets} sets × {exercise?.reps} reps</span>
              <span>•</span>
              <span>{exercise?.restSeconds}s rest</span>
              <span>•</span>
              <span className="flex items-center gap-1">
                <Icon name="Clock" size={12} />
                {duration} min
              </span>
            </div>
            {exercise?.notes && (
              <p className="text-xs text-muted-foreground mt-2 line-clamp-1">{exercise?.notes}</p>
            )}
          </div>

          <Button
            size="sm"
            variant="outline"
            onClick={(e) => {
              e?.stopPropagation();
              onRemove();
            }}
            className="flex-shrink-0"
          >
            <Icon name="Trash2" size={14} className="text-destructive" />
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default SortableExerciseItem;